(() => {
  if (window.__mytoogoGuestCheckoutBound) return;
  window.__mytoogoGuestCheckoutBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-mytoogo-guest-checkout]');
    if (!button || button.disabled || button.dataset.loading === 'true') return;

    const form = button.closest('form');
    if (!form) return;
    if (!form.reportValidity()) return;

    const productForm = button.closest('product-form-component');
    const addButton = productForm?.querySelector('button[name="add"]');
    const errorElement = button.parentElement?.querySelector('[data-mytoogo-guest-error]');
    if (errorElement) { errorElement.hidden = true; errorElement.textContent = ''; }

    if (addButton?.disabled) {
      if (errorElement) { errorElement.textContent = 'Please select an available product option.'; errorElement.hidden = false; }
      return;
    }

    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput && !quantityInput.reportValidity()) return;

    const selector = productForm?.querySelector('quantity-selector-component');
    const validation = selector?.canAddToCart?.();
    if (validation && !validation.canAdd) {
      if (errorElement) { errorElement.textContent = 'Please check your selected quantity.'; errorElement.hidden = false; }
      return;
    }

    const formData = new FormData(form);
    if (!formData.get('id')) {
      if (errorElement) { errorElement.textContent = 'Please select a product option.'; errorElement.hidden = false; }
      return;
    }

    const selectedQuantity = Number(selector?.getValue?.() || formData.get('quantity') || 1);
    if (!Number.isInteger(selectedQuantity) || selectedQuantity < 1) {
      if (errorElement) { errorElement.textContent = 'Please enter a valid quantity.'; errorElement.hidden = false; }
      return;
    }
    formData.set('quantity', String(selectedQuantity));

    const originalLabel = button.textContent;
    button.disabled = true;
    button.dataset.loading = 'true';
    button.textContent = 'Taking you to checkout…';

    try {
      const response = await fetch(button.dataset.cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => null);
        throw new Error(payload?.description || payload?.message || 'Could not add the item to the basket.');
      }
      // The cart addition has succeeded. Don't wait to download and parse its
      // full JSON response before opening Shopify's standard checkout.
      window.location.assign(button.dataset.checkoutUrl || '/checkout');
    } catch (error) {
      if (errorElement) {
        errorElement.textContent = error?.message || 'Please try again or use Add to cart.';
        errorElement.hidden = false;
      }
      button.disabled = false;
      button.dataset.loading = 'false';
      button.textContent = originalLabel;
    }
  });
})();